import { createStore, createEffect, createEvent, combine } from 'effector';
import request from '@helpers/request';
import createPreloadersStore from './preloaders';
import api from '@constants/endpoints';

export const reset = createEvent('Claims store reset');

interface GetClaimsParams {
  userId: string;
  author: string;
}

export const getClaimsDetails = createEffect<GetClaimsParams, any>({
  name: 'getClaimsDetails',
  async handler({ userId, author }) {
    const [accountClaims, postsClaims, commentsClaims, statusesClaims] = await Promise.all([
      request(api.spam.getUserComplaintReasons, {
        data: {
          pagination: { type: 'PAGE', page: 0, pageSize: 100 },
        },
        urlParams: { accountId: userId },
      }),
      request(api.spam.getList, { params: { author } }),
      request(api.spam.getComments, { params: { author } }),
      request(api.spam.getStatuses, {
        data: {
          pagination: { type: 'PAGE', page: 0, pageSize: 100 },
          statusAuthorId: userId,
        },
      }),
    ]);

    const accountArray = accountClaims.data.body?.result?.page || [];

    const postsArray =
      postsClaims.data.body?.content?.flatMap((item: any) => item.claims || []) || [];

    const commentsArray =
      commentsClaims.data.body?.content?.flatMap((item: any) => item.claims || []) || [];

    const statusesArray = statusesClaims.data.body?.claimedStatuses?.page || [];
    const allStatusClaims = statusesArray.flatMap((status: any) => status.claims || []);

    return {
      accountClaimsCount: accountArray.length,
      accountReasons: accountArray.reduce((acc: any, claim: any) => {
        const reason = claim.type || 'Other';
        acc[reason] = (acc[reason] || 0) + 1;
        return acc;
      }, {}),

      postsClaimsCount: postsArray.length,
      postsReasons: postsArray.reduce((acc: any, claim: any) => {
        const reason = claim.type || 'Other';
        acc[reason] = (acc[reason] || 0) + 1;
        return acc;
      }, {}),

      commentsClaimsCount: commentsArray.length,
      commentsReasons: commentsArray.reduce((acc: any, claim: any) => {
        const reason = claim.type || 'Other';
        acc[reason] = (acc[reason] || 0) + 1;
        return acc;
      }, {}),

      statusesClaimsCount: allStatusClaims.length,
      statusesReasons: allStatusClaims.reduce((acc: any, claim: any) => {
        const reason = claim.type || 'Other';
        acc[reason] = (acc[reason] || 0) + 1;
        return acc;
      }, {}),
    };
  },
});

const preloaders = createPreloadersStore([getClaimsDetails]);

const list = createStore<any>({})
  .on(getClaimsDetails.done, (_, payload) => payload)
  .reset(reset);

const claims = combine({ preloaders, list });

export default claims;
